export const assign = (r, x) => Object.assign(r, x)
